<template>
  <base-sheet :visible="visible" aria-label="Avisos do app" @close="$emit('dismiss')">
    <div class="vxl-sheet__head">
      <span class="vxl-sheet__icon" :style="{ color: $theme.primaryColor }">
        <i class="material-icons">notifications_active</i>
      </span>
      <div class="vxl-sheet__head-text">
        <h3 class="vxl-sheet__title">{{ title }}</h3>
      </div>
    </div>

    <p class="vxl-sheet__subtitle push-permission__text">{{ text }}</p>

    <p v-if="denied" class="vxl-sheet__note">
      As notificações deste app estão desligadas no seu aparelho. Para receber os
      avisos, é só ativar nos Ajustes.
    </p>
    <p v-else-if="trigger !== 'entry'" class="vxl-sheet__note">
      Você escolhe o que receber em Configurações, quando quiser.
    </p>

    <button
      type="button"
      class="vxl-sheet__action vxl-sheet__action--primary"
      :style="{ background: $theme.primaryColor }"
      @click="$emit('accept')"
    >
      <i class="material-icons">{{ denied ? 'settings' : 'notifications' }}</i>
      {{ denied ? 'Ativar nos Ajustes' : 'Quero ser avisado' }}
    </button>
    <button type="button" class="vxl-sheet__action vxl-sheet__action--ghost" @click="$emit('decline')">
      Agora não
    </button>
  </base-sheet>
</template>

<script>
import BaseSheet from '@/components/base/BaseSheet';

// Pedido de permissão de notificação (STORY-1642; entrada na área logada, sc-6255). Só explica e
// devolve a escolha; quem decide QUANDO abrir e o que fazer com a resposta é o
// services/push/pushPrompt.
//
// Eventos: accept | decline ("Agora não" — não perguntamos de novo, exceto na
// entrada na área logada, que só fecha) | dismiss (toque fora/handle — sem decisão).
export default {
  name: 'PushPermissionSheet',
  components: { BaseSheet },
  props: {
    visible: { type: Boolean, default: false },
    trigger: { type: String, default: null },
    denied: { type: Boolean, default: false }
  },
  computed: {
    title () {
      if (this.trigger === 'entry') return 'Não perca nenhuma aula nova';
      return this.trigger === 'comment'
        ? 'Quer ser avisado quando responderem?'
        : 'Quer saber quando chegar aula nova?';
    },
    text () {
      if (this.trigger === 'entry') return 'Seja avisado de aulas novas e de respostas aos seus comentários.';
      return this.trigger === 'comment'
        ? 'A gente te avisa assim que alguém responder o seu comentário, para você continuar a conversa.'
        : 'A gente te avisa quando os seus cursos ganharem aulas novas, sem exagero: as novidades de cada curso chegam juntas, num aviso só.';
    }
  }
};
</script>

<style scoped lang="scss">
.push-permission__text {
  margin-top: 12px;
}
</style>
